export default __webpack_public_path__ + "media/images/borders/brown-border-1b303c7a8325c0a229e264db79d76353.svg";